import { render } from "./InformationPanel.vue?vue&type=template&id=24c9c97a&scoped=true"
import script from "./InformationPanel.vue?vue&type=script&lang=ts"
export * from "./InformationPanel.vue?vue&type=script&lang=ts"

import "./InformationPanel.vue?vue&type=style&index=0&id=24c9c97a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24c9c97a"

export default script